var _defs, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinitySymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .infinitySymbolCls-1 {\n        fill: white;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.82,76.87c39.27,0,73.9,22.63,93.27,56.18,17.45-27.54,47.72-46.91,81.81-46.91,58.63,0,106.08,51,106.08,113.72s-47.45,113.72-106.08,113.72c-34.09,0-64.36-19.36-81.81-47.18-19.36,34.36-54,56.72-93.27,56.72-63.27,0-114.81-55.09-114.81-123.27S53.28,76.87,116.82,76.87Zm0,197.44c38.45,0,68.99-33.27,68.99-74.45s-30.54-74.45-68.99-74.45-69,33.55-69,74.45,30.82,74.45,69,74.45Zm175.08-9.27c33.27,0,60.27-29.18,60.27-65.18s-27-65.18-60.27-65.18-60.27,29.18-60.27,65.18,27,65.18,60.27,65.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinitySymbol);
export default __webpack_public_path__ + "static/media/InfinitySymbol.c59b898b39fcf3644cb9c2c9d17d461e.svg";
export { ForwardRef as ReactComponent };